import * as Factory from 'factory.ts'
import faker from 'faker'

import { type Department } from '../../models'

export const SINGLE_DEPARTMENT: Department = {
  id: 190,
  branch: {
    id: 6,
    name: 'Luettgen and Sons',
    headquarter: false,
  },
  external_id: '',
  name: 'Upload Department 2',
  active: true,
}

export const DepartmentMock = Factory.Sync.makeFactory<Department>({
  id: Factory.each(() => faker.random.number()),
  active: true,
  external_id: faker.lorem.word(),
  name: Factory.each((idx) => `${faker.commerce.department()}_${idx}`),
  branch: {
    id: faker.random.number(),
    name: faker.address.city(),
    headquarter: true,
  },
  punchout_email: '',
})
